export default {
  "actionButton": {
    "config": {
      "changed": false,
      "title": "Buttons",
      "navSection": "settings",
      "icon": "actionButton",
      "image": "buttons.png"
    },
    "items": {
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "image": {
    "config": {
      "changed": false,
      "title": "Image",
      "navSection": "settings",
      "icon": "image",
      "image": "image.png"
    },
    "items": {
      "imageScaling": {
        "imageScalingType": "Normal"
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "shape": {
    "config": {
      "changed": false,
      "title": "Shapes",
      "navSection": "settings",
      "icon": "basicShape",
      "image": "basicShape.png"
    },
    "items": {
      "line": {
        "lineColor": "#252423",
        "transparency": 0,
        "weight": 3,
        "roundEdge": 0
      },
      "fill": {
        "show": true,
        "fillColor": "#DDDDDD",
        "transparency": 0
      },
      "shape": {
        "tileShape": "rectangle",
        "roundEdge": 1,
        "linecapType": "flat"
      },
      "shadow": {
        "show": false,
        "color": "#252423",
        "transparency": 0,
        "shadowBlur": 0,
        "shadowPositionPreset": "BottomRight",
        "angle": 45,
        "shadowDistance": 50
      },
      "glow": {
        "show": false,
        "color": "#252423",
        "transparency": 0,
        "shadowBlur": 0
      },
      "rotation": {
        "angle": 0
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "textbox": {
    "config": {
      "changed": true,
      "title": "Textbox / Smart Narrative",
      "navSection": "settings",
      "icon": "textbox",
      "image": "textbox.png"
    },
    "items": {
      "*": {
        "fontSize": 10,
        "fontFamily": "Segoe UI Light",
        "wordWrap": true,
        "color": "#020f47"
      },
      "title": {
        "show": false,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "DIN"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 30,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  }
}